<template>
    <!--<a href="/logout"></a>-->
    <h1>Login Success</h1>
</template>

<script>
    export default {
        name: "home"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/home.vue